import React, { useCallback } from 'react';

import { useIntl } from 'react-intl';

import { useFlags } from '@atlaskit/flag';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import { token } from '@atlaskit/tokens';

import flagMessages from '../../../../messages';

import { StoreErrorFlagId } from './StoreErrorFlagId';

export const useShowStoreErrorFlag = (): ((flagId: StoreErrorFlagId) => void) => {
	const { showFlag: showFlagFromFlags } = useFlags();
	const { formatMessage } = useIntl();

	const showFlag = useCallback(
		(flagId: StoreErrorFlagId) => {
			switch (flagId) {
				case StoreErrorFlagId.CONVERSATION_FORBIDDEN:
					showFlagFromFlags({
						id: 'conversation-assistant.conversation-forbidden',
						title: formatMessage(flagMessages.conversationForbiddenTitle),
						description: formatMessage(flagMessages.conversationForbiddenDescription),
						icon: <StatusErrorIcon color={token('color.icon.danger')} label="" />,
						isAutoDismiss: true,
					});
					break;
				case StoreErrorFlagId.CONVERSATION_HISTORY_LOAD_FAILED:
					showFlagFromFlags({
						id: 'conversation-assistant.conversation-history-load-failed',
						title: formatMessage(flagMessages.conversationHistoryLoadFailedTitle),
						description: formatMessage(flagMessages.conversationHistoryLoadFailedDescription),
						icon: <StatusErrorIcon color={token('color.icon.danger')} label="" />,
						isAutoDismiss: true,
					});
					break;
			}
		},
		[showFlagFromFlags, formatMessage],
	);

	return showFlag;
};
